import React from "react";
import "./App.css";
import "bootstrap/dist/js/bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import "./assets/css/adminlte.css";
import "./assets/css/fontawesome-all.css";
// View
import Login from "./views/LoginV2";
import ProgramView from "./views/Member/ViewProgram";
import AdminLayout from "./layout/admin";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/login" render={(props) => <Login {...props} />}></Route>
        <Route
          path="/program/view/:id"
          render={(props) => <ProgramView {...props} />}
        ></Route>
        <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
        <Redirect from="/" to="/login" />
      </Switch>
    </Router>
  );
}

export default App;
